import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimary from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-sofyre-timeline.js';

const buttonHtml = buttonPrimary({
  text: 'ADD TO CART',
  backgroundColor: '#ccf46f',
  color: '#23372b',
  radius: 100,
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/09/08/image-6a9fb3c9503aaa5482a117ec.png',
  },
});

const featureHtml = (title, content) => `
  <div class="sofyre-timeline__feature" data-attribute="sofyre-timeline__feature">
    <div class="sofyre-timeline__feature-title" data-attribute="sofyre-timeline__feature-title">
      ${title}
    </div>
    <div class="sofyre-timeline__feature-content" data-attribute="sofyre-timeline__feature-content">
      ${content}
    </div>
  </div>
`;

const timelineTabs = [
  {
    id: 'sofyre-tab-1',
    label: 'HOURS 1-72',
    tag: 'HOUR 1-72',
    title: '<h3>MICE RETREAT IMMEDIATELY</h3>',
    features: [
      {
        title: '<p><span style="color:#9B4600;">Peppermint oil triggers the trigeminal nerve on contact</span></p>',
        content:
          '<p><span><i>Hardwired survival instinct fires — brain signals immediate predator threat</i></span></p>',
      },
      {
        title: '<p><span style="color:#9B4600;">Pheromone trails completely disrupted</span></p>',
        content: '<p><span><i>Mice can no longer navigate safe routes or communicate with each other</i></span></p>',
      },
      {
        title: '<p><span style="color:#9B4600;">Every entry point blocked</span></p>',
        content:
          '<p><span><i>Each pouch creates a 65 sq. ft. invisible barrier — unlike traps that cover one spot</i></span></p>',
      },
    ],
  },
  {
    id: 'sofyre-tab-2',
    label: 'WEEK 1',
    tag: 'WEEK 1',
    title: '<h3>YOUR HOME BECOMES HOSTILE TERRITORY</h3>',
    features: [
      {
        title: '<p><span style="color:#9B4600;">Mice try alternative entry points — every one is blocked</span></p>',
        content: '<p><span><i>Overlapping barriers leave zero gaps in your perimeter</i></span></p>',
      },
      {
        title: '<p><span style="color:#9B4600;">Stress hormones remain permanently elevated</span></p>',
        content: '<p><span><i>Constant nerve activation makes your property feel dangerous and unsafe</i></span></p>',
      },
      {
        title:
          '<p><span style="color:#9B4600;">They cannot nest. They cannot settle. They cannot survive here.</span></p>',
        content:
          '<p><span><i>Without safe pathways or communication, mouse behaviour breaks down completely</i></span></p>',
      },
    ],
  },
  {
    id: 'sofyre-tab-3',
    label: 'WEEK 2',
    tag: 'WEEK 2',
    title: '<h3>NO WAY TO RESIST</h3>',
    features: [
      {
        title: '<p><span style="color:#9B4600;">Unlike poison — they can never build tolerance to this</span></p>',
        content:
          '<p><span><i>Mice develop resistance to poison over generations. Nerve response is impossible to override.</i></span></p>',
      },
      {
        title: '<p><span style="color:#9B4600;">Unlike traps — they can never learn to avoid it</span></p>',
        content:
          '<p><span><i>Traps are physical — mice memorise them. Nerve activation cannot be outsmarted.</i></span></p>',
      },
      {
        title: '<p><span style="color:#9B4600;">The same overwhelming response fires every single time</span></p>',
        content: '<p><span><i>No exceptions. No adaptation. Ever.</i></span></p>',
      },
    ],
  },
  {
    id: 'sofyre-tab-4',
    label: 'WEEK 3',
    tag: 'WEEK 3',
    title: '<h3>THEY HAVE LEFT. AND THEY KNOW NOT TO RETURN.</h3>',
    features: [
      {
        title: '<p><span style="color:#9B4600;">Mice completely abandon your property</span></p>',
        content:
          '<p><span><i>Permanent avoidance established — your home is no longer a viable location</i></span></p>',
      },
      {
        title: '<p><span style="color:#9B4600;">Sofyre stays active for up to 90 days</span></p>',
        content: '<p><span><i>4-oil formula maintains full potency — no reapplying, no maintenance</i></span></p>',
      },
      {
        title: '<p><span style="color:#9B4600;">No new mice can move in or leave scent markers</span></p>',
        content: '<p><span><i>No corpses. No cleanup. No poison. Just silence.</i></span></p>',
      },
    ],
  },
];

const tabHeaderHtml = timelineTabs
  .map(
    (tab, index) => `
      <button
        type="button"
        class="sofyre-timeline__tab-header tab-header-item${index === 0 ? ' active' : ''}"
        data-attribute="tab-header-item"
        data-tab="${tab.id}"
        aria-selected="${index === 0 ? 'true' : 'false'}"
      >${tab.label}</button>
    `,
  )
  .join('');

const tabContentHtml = timelineTabs
  .map(
    (tab, index) => `
      <article
        class="sofyre-timeline__tab-content tab-content-item${index === 0 ? ' active' : ''}"
        data-attribute="tab-content-item"
        data-tab="${tab.id}"
      >
        <div class="sofyre-timeline__timeline">
          <span class="sofyre-timeline__marker" aria-hidden="true">
            <svg data-name="Group 1484581850 (1).svg" data-id="610890338768257833" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" fill="none">
              <circle cx="19.5" cy="19.5" r="19.5" fill="#D9E8D0"></circle>
              <circle cx="19.5" cy="19.4998" r="14.1207" fill="#BFD5B2"></circle>
              <circle cx="19.5" cy="19.4997" r="8.74138" fill="#23372B"></circle>
            </svg>
          </span>
          <div class="sofyre-timeline__tag" data-attribute="sofyre-timeline__tag">${tab.tag}</div>
          <div class="sofyre-timeline__tab-title" data-attribute="sofyre-timeline__tab-title">
            ${tab.title}
          </div>
          <div class="sofyre-timeline__features" data-attribute="sofyre-timeline__features">
            ${tab.features.map(item => featureHtml(item.title, item.content)).join('')}
          </div>
        </div>
      </article>
    `,
  )
  .join('');

const contentHtml = `
  <div
    class="sofyre-timeline container"
    data-attribute="sofyre-timeline"
    data-primary-color="#23372B"
    style="--color-primary: #23372B;"
  >
    <header class="sofyre-timeline__header" data-attribute="sofyre-timeline__header">
      <h2 style="text-align: center">
        <span>Here's Exactly What Happens</span><br />
        <span>After You Place A Pouch</span>
      </h2>
    </header>

    <div
      class="sofyre-timeline__layout"
      data-attribute="sofyre-timeline__layout"
      data-image-position="left"
      data-image-show="true"
    >
      <div class="sofyre-timeline__image" data-attribute="sofyre-timeline__image" data-show="true">
        <img
          data-attribute="sofyre-timeline__image-img"
          src="https://cdn.skyfastimg.com/images/2026/09/08/image-6a9f84488b576415328208f8.webp?w=1000"
          alt="Sofyre rodent repellent pouches"
          loading="lazy"
        >
      </div>

      <div class="sofyre-timeline__panel">
        <div class="sofyre-timeline__tabs" data-attribute="list-tab-header">
          ${tabHeaderHtml}
        </div>
        <div class="sofyre-timeline__guide" data-attribute="sofyre-timeline__guide">
          <img
            data-attribute="sofyre-timeline__guide-image"
            src="https://cdn.skyfastimg.com/images/2026/09/08/image-6a9f92221d0336fb35796f5f.png"
            alt=""
          >
          <span data-attribute="sofyre-timeline__guide-text">Tap on each box to view progress by week</span>
        </div>
        <div class="sofyre-timeline__tab-contents" data-attribute="list-tab-content">
          ${tabContentHtml}
        </div>
      </div>
    </div>

    <div class="sofyre-timeline__cta">
      ${buttonHtml}
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#F1F3E9',
  textColor: '#23372B',
  topPadding: true,
  bottomPadding: true,
});
